module.exports = __webpack_public_path__ + "img/displacement-PROG-STANDARD.a1f89f70.png";